module.exports = __webpack_public_path__ + "static/media/Loader.1dc7c71e.gif";